import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CustomerDistributionLoadingEdit',
    props: {
        type: {}
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            const _component_el_skeleton_item = _resolveComponent("el-skeleton-item");
            const _component_el_skeleton = _resolveComponent("el-skeleton");
            return (props.type === 'input')
                ? (_openBlock(), _createBlock(_component_el_skeleton, {
                    key: 0,
                    loading: true,
                    animated: ""
                }, {
                    template: _withCtx(() => [
                        _createVNode(_component_el_skeleton_item, {
                            variant: "text",
                            style: { "width": "600px", "height": "30px", "border-radius": "20px" }
                        })
                    ]),
                    _: 1
                }))
                : (props.type === 'drag')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(_component_el_skeleton, {
                            loading: true,
                            animated: ""
                        }, {
                            template: _withCtx(() => [
                                _createVNode(_component_el_skeleton_item, {
                                    variant: "text",
                                    style: { "width": "570px", "height": "300px", "border-radius": "20px", "border-bottom": "16px" }
                                })
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_el_skeleton, {
                            loading: true,
                            animated: ""
                        }, {
                            template: _withCtx(() => [
                                _createVNode(_component_el_skeleton_item, {
                                    variant: "text",
                                    style: { "width": "570px", "height": "300px", "border-radius": "20px" }
                                })
                            ]),
                            _: 1
                        })
                    ], 64))
                    : (props.type === 'toggle')
                        ? (_openBlock(), _createBlock(_component_el_skeleton, {
                            key: 2,
                            loading: true,
                            animated: ""
                        }, {
                            template: _withCtx(() => [
                                _createVNode(_component_el_skeleton_item, {
                                    variant: "button",
                                    style: { "width": "40px", "height": "20px", "border-radius": "20px" }
                                })
                            ]),
                            _: 1
                        }))
                        : (props.type === 'alert')
                            ? (_openBlock(), _createBlock(_component_el_skeleton, {
                                key: 3,
                                loading: true,
                                animated: ""
                            }, {
                                template: _withCtx(() => [
                                    _createVNode(_component_el_skeleton_item, {
                                        variant: "text",
                                        style: { "width": "600px", "height": "100px", "border-radius": "20px" }
                                    })
                                ]),
                                _: 1
                            }))
                            : (props.type === 'buttons')
                                ? (_openBlock(), _createBlock(_component_el_skeleton, {
                                    key: 4,
                                    loading: true,
                                    animated: ""
                                }, {
                                    template: _withCtx(() => [
                                        _createVNode(_component_el_skeleton_item, {
                                            variant: "button",
                                            style: { "width": "160px", "height": "35px", "border-radius": "20px" }
                                        }),
                                        _createVNode(_component_el_skeleton_item, {
                                            variant: "button",
                                            style: { "width": "160px", "height": "35px", "border-radius": "20px" }
                                        })
                                    ]),
                                    _: 1
                                }))
                                : _createCommentVNode("", true);
        };
    }
});
